import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportMonthlyPerformanceService extends GenericService {
    constructor() {
        super('/reports/monthly_performance', axiosInstance);
    }

    async getFullReport(classicFilters = {}) {
        const params = {};
        if (classicFilters.month?.query?.value) {
            params.month = classicFilters.month.query.value;
        }
        const response = await axiosInstance.get(
            `${this.baseURL}/full-report`,
            { params }
        );
        return response.data;
    }
}

export default new ReportMonthlyPerformanceService();
